import { ConcreteEncodable } from "./ConcreteEncodable";

import { StrategyComponentStateImplEncoder } from "../../encoder/StrategyComponentStateImplEncoder";

import * as CubiqTS from "../../index";
import { StrategyComponentState } from "../StrategyComponentState";

export class StrategyComponentStateImpl
  extends ConcreteEncodable
  implements StrategyComponentState
{
  public static enType: string = "com.bcdfx.model.event.lifecycle.StrategyComponentStateImpl";

  /*FID=1*/
  public strategyId: string;
  /*FID=2*/
  public orderId: string;
  /*FID=3*/
  public externalReference: string;
  /*FID=4*/
  public orderState: CubiqTS.OrderState;
  /*FID=5*/
  public relationships: Array<CubiqTS.Relationship> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = StrategyComponentStateImplEncoder.Instance;
    this.setEncodableType(StrategyComponentStateImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "StrategyComponentStateImpl[" +
      "strategyId=" +
      this.strategyId +
      "orderId=" +
      this.orderId +
      "externalReference=" +
      this.externalReference +
      "orderState=" +
      this.orderState +
      "relationships=" +
      this.relationships +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
